import { resetTimeout } from '../../utils/wait';
import {
  PaymentActionRequiredError,
  PaymentDefaultError,
} from '../Errors/customErrors';

export const INTERVAL = 5000; // 5 seconds

let token = '';

export const getToken = () => {
  if (token.length === 0 || !token) {
    throw new PaymentDefaultError('Payment token is empty');
  }

  return token;
};
export const setToken = (newToken: string) => {
  token = newToken;
};

let isClosed = false;

export const getIsClosed = () => isClosed;
export const setIsClosed = (newIsClosed: boolean) => {
  isClosed = newIsClosed;
};

let isExpired = false;

export const getIsExpired = () => isExpired;
export const setIsExpired = (newIsExpired: boolean) => {
  isExpired = newIsExpired;
};

export const validateQRModalIsExpired = () => {
  if (getIsClosed() && getIsExpired()) {
    throw new PaymentActionRequiredError(
      'FPS QR is expired and user closed the modal',
      'HkFps',
    );
  }
};

export const validateQRModalIsClosed = () => {
  if (getIsClosed()) {
    resetTimeout();
    throw new PaymentActionRequiredError('User closed the modal', 'IdQr');
  }
};
